import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from 'lazy-route';

const examRoutes = [
  <Route
    key="exams"
    exact
    path="/exams/:packid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/Exam")}
      />
    )}
  />,
  <Route
    key="exam-session"
    exact
    path="/exams/:packid/:sessionid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/ExamSession")}
      />
    )}
  />,
  <Route
    key="preview"
    exact
    path="/preview/:packid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/ExamPreview")}
      />
    )}
  />,
  <Route
    key="edit"
    exact
    path="/edit/:packid"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/admin/pages/ExamEdit")}
      />
    )}
  />,
  <Route
    key="elearning"
    exact
    path="/elearning"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/features/user/pages/Elearning")}
      />
    )}
  />
];

export default examRoutes; 